import { FC } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import UpdateUpload from 'modules/Update/components/UpdateUpload';
import { PicProofEnum } from 'types/common';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const descriptions: string[] = [
    __(
        'Please upload your proof of address issued within 3 months; e.g. utility bill, bank statement or broker statement, mortgage bill, rental or lease agreement.'
    ),
    __('Please ensure the photo is clear and contains your name and address, the issue date, and the issuing body.')
];

/**
 *  地址证明页
 */
const Residence: FC<ProgressFormProps> = ({ onSubmit }) => {
    return (
        <form className="open-residence-root" noValidate onSubmit={ev => onSubmit('../job', ev)}>
            <h3 className="open-title mt-0">{__('Upload the Proof of Address')}</h3>
            <UpdateUpload
                type={PicProofEnum.PIC_RESIDENCE}
                desc={
                    <>
                        {descriptions.map((desc, index) => (
                            <p key={index} className="mb-2">
                                {desc}
                            </p>
                        ))}
                    </>
                }
            />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    id: 'residence',
    step: 2,
    basePath: 'open',
    eventParams: {
        exposureEventParams: {
            model: '开户-地址证明',
            name: '地址证明-页面曝光'
        },
        submitEventParams: {
            model: '开户-地址证明',
            name: '地址证明-点击下一步'
        }
    }
})(Residence);
